import moment from 'moment';
import { createDataSets } from './createDataSets';

export const handleMapData = (selectedMarket, users, data, setChartData) => {
	const labels = data.map((d) => moment(d.from).format('YYYY-MM-DD'));

	setChartData(() => ({
		labels: labels,
		datasets: createDataSets(selectedMarket, users, data),
	}));
};
